
export class RevisionsResult<T> {
    public results: T[];
    public totalResults: number;
}